import { TypeSerializer } from '@/common/utils/typeSerializer'

/**
 * Каждая запись `fields.fields` js-response — `{type,value}` (middle UniDataTableFieldsDeserializer).
 * Идемпотентно для уже типизированных полей.
 */
export function ensureUniDataWireFields(
  fields: Record<string, unknown> = {},
): Record<string, unknown> {
  const out: Record<string, unknown> = {}
  for (const [key, value] of Object.entries(fields)) {
    out[key] = TypeSerializer.serialize(value)
  }
  return out
}

/**
 * Базовый каркас UniData для ответов WS js-request (успех и exception).
 * Совпадает с форматом `createBaseUniDataResponse` в GlobalProvider.
 */
export function createBaseUniDataResponse(
  fields: Record<string, unknown> = {},
  hasFormError = false,
): Record<string, unknown> {
  return {
    fields: {
      hasFormError,
      fieldAttributes: {},
      errors: {},
      attributes: {},
      fields,
    },
    clientData: {
      elementConditions: null,
      reloadActions: null,
      params: {},
      doActionId: 0,
      openPage: null,
    },
  }
}
